import { render, staticRenderFns } from "./ImportantDocuments.vue?vue&type=template&id=73516273"
import script from "./ImportantDocuments.vue?vue&type=script&lang=js"
export * from "./ImportantDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports